import { errors } from '@sopheos/orbjs_lang';
import errorsData from '../../assets/lang/errors.json';

export default errors(errorsData);
